interface TokenCheckboxProps {
  label: string;
  checked: boolean;
  onToggle: () => void;
}

export function TokenCheckbox({ label, checked, onToggle }: TokenCheckboxProps) {
  return (
    <label className="group inline-flex items-center gap-1.5 cursor-pointer select-none font-lato text-[12px] font-semibold text-rodeo-black">
      <input type="checkbox" checked={checked} onChange={onToggle} className="sr-only" />
      <span
        className="flex items-center justify-center shrink-0 transition-all duration-150"
        style={{
          width: 16,
          height: 16,
          borderRadius: 3,
          border: `1.5px solid ${checked ? "var(--color-dark-dust)" : "var(--color-smoke)"}`,
          background: checked ? "var(--color-dark-dust)" : "var(--color-white)",
        }}
      >
        {checked && (
          <svg width="9" height="7" viewBox="0 0 9 7" fill="none" aria-hidden="true">
            <path
              d="M1 3.5L3.5 6L8 1"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </span>
      {label}
    </label>
  );
}
